import http from 'plugins/axios';

export default {
  // 获取提交次数
  getAuthApply() {
    return http.get({
      url: '/admin/authConfig/getAuthApplyCount'
    });
  },
  // 获取提现数量
  getKycWithdrawal() {
    return http.get({
      url: `/admin/authConfig/getKycWithdrawalConfig`
    });
  },
  // 修改提交次数
  updateApplyNum(data) {
    return http.post({
      url: '/admin/authConfig/updateAuthApplyCount',
      data: data,
      dataType: 'form'
    });
  },
  // 修改提现数量
  updateKycWithdrawal(data) {
    return http.post({
      url: '/admin/authConfig/updateKycWithdrawalConfig',
      data: data,
      dataType: 'form'
    });
  },
};
